export const oldBookSet = {
  창세기: {
    pageNumber: 50,
    name: "Genesis",
    koreanName: "창세기",
  },
  출애굽기: {
    pageNumber: 40,
    name: "Exodus",
    koreanName: "출애굽기",
  },
  레위기: {
    pageNumber: 27,
    name: "Leviticus",
    koreanName: "레위기",
  },
  민수기: {
    pageNumber: 36,
    name: "Numbers",
    koreanName: "민수기",
  },
  신명기: {
    pageNumber: 34,
    name: "Deuteronomy",
    koreanName: "신명기",
  },
  여호수아: {
    pageNumber: 24,
    name: "Joshua",
    koreanName: "여호수아",
  },
  사사기: {
    pageNumber: 21,
    name: "Judges",
    koreanName: "사사기",
  },
  룻기: {
    pageNumber: 4,
    name: "Ruth",
    koreanName: "룻기",
  },
  사무엘상: {
    pageNumber: 31,
    name: "1 Samuel",
    koreanName: "사무엘상",
  },
  사무엘하: {
    pageNumber: 24,
    name: "2 Saumuel",
    koreanName: "사무엘하",
  },
  열왕기상: {
    pageNumber: 22,
    name: "1 Kings",
    koreanName: "열왕기상",
  },
  열왕기하: {
    pageNumber: 25,
    name: "2 Kings",
    koreanName: "열왕기하",
  },
  역대상: {
    pageNumber: 29,
    name: "1 Chronicles",
    koreanName: "역대상",
  },
  역대하: {
    pageNumber: 36,
    name: "2 Chronicles",
    koreanName: "역대하",
  },
  에스라: {
    pageNumber: 10,
    name: "Ezra",
    koreanName: "에스라",
  },
  느헤미야: {
    pageNumber: 13,
    name: "Nehemiah",
    koreanName: "느헤미야",
  },
  에스더: {
    pageNumber: 10,
    name: "Esther",
    koreanName: "에스더",
  },
  욥기: {
    pageNumber: 42,
    name: "Job",
    koreanName: "욥기",
  },
  시편: {
    pageNumber: 150,
    name: "Psalms",
    koreanName: "시편",
  },
  잠언: {
    pageNumber: 31,
    name: "Proverbs",
    koreanName: "잠언",
  },
  전도서: {
    pageNumber: 12,
    name: "Ecclesiastes",
    koreanName: "전도서",
  },
  아가: {
    pageNumber: 8,
    name: "Song of Solomon",
    koreanName: "아가",
  },
  이사야: {
    pageNumber: 66,
    name: "Isaiah",
    koreanName: "이사야",
  },
  예레미야: {
    pageNumber: 52,
    name: "Jeremiah",
    koreanName: "예레미야",
  },
  예레미야애가: {
    pageNumber: 5,
    name: "Lamentations",
    koreanName: "예레미야애가",
  },
  에스겔: {
    pageNumber: 48,
    name: "Ezekiel",
    koreanName: "에스겔",
  },
  다니엘: {
    pageNumber: 12,
    name: "Daniel",
    koreanName: "다니엘",
  },
  호세아: {
    pageNumber: 14,
    name: "Hosea",
    koreanName: "호세아",
  },
  요엘: {
    pageNumber: 3,
    name: "Joel",
    koreanName: "요엘",
  },
  아모스: {
    pageNumber: 9,
    name: "Amos",
    koreanName: "아모스",
  },
  오바댜: {
    pageNumber: 1,
    name: "Obadiah",
    koreanName: "오바댜",
  },
  요나: {
    pageNumber: 4,
    name: "Jonah",
    koreanName: "요나",
  },
  미가: {
    pageNumber: 7,
    name: "Micah",
    koreanName: "미가",
  },
  나훔: {
    pageNumber: 3,
    name: "Nahum",
    koreanName: "나훔",
  },
  하박국: {
    pageNumber: 3,
    name: "Habakkuk",
    koreanName: "하박국",
  },
  스바냐: {
    pageNumber: 3,
    name: "Zephaniah",
    koreanName: "스바냐",
  },
  학개: {
    pageNumber: 2,
    name: "Haggai",
    koreanName: "학개",
  },
  스가랴: {
    pageNumber: 14,
    name: "Zechariah",
    koreanName: "스가랴",
  },
  말라기: {
    pageNumber: 4,
    name: "Malachi",
    koreanName: "말라기",
  },
};
export const newBookSet = {
  마태복음: {
    pageNumber: 28,
    name: "Matthew",
    koreanName: "마태복음",
  },
  마가복음: {
    pageNumber: 16,
    name: "Mark",
    koreanName: "마가복음",
  },
  누가복음: {
    pageNumber: 24,
    name: "Luke",
    koreanName: "누가복음",
  },
  요한복음: {
    pageNumber: 21,
    name: "John",
    koreanName: "요한복음",
  },
  사도행전: {
    pageNumber: 28,
    name: "Acts",
    koreanName: "사도행전",
  },
  로마서: {
    pageNumber: 16,
    name: "Romans",
    koreanName: "로마서",
  },
  고린도전서: {
    pageNumber: 16,
    name: "1+Corinthians",
    koreanName: "고린도전서",
  },
  고린도후서: {
    pageNumber: 13,
    name: "2+Corinthians",
    koreanName: "고린도전서",
  },
  갈라디아서: {
    pageNumber: 6,
    name: "Galatians",
    koreanName: "갈라디아서",
  },
  에베소서: {
    pageNumber: 6,
    name: "Ephesians",
    koreanName: "에베소서",
  },
  빌립보서: {
    pageNumber: 4,
    name: "Philippians",
    koreanName: "빌립보서",
  },
  골로새서: {
    pageNumber: 4,
    name: "Colossians",
    koreanName: "골로새서",
  },
  데살로니가전서: {
    pageNumber: 5,
    name: "1+Thessalonians",
    koreanName: "데살로니가전서",
  },
  데살로니가후서: {
    pageNumber: 3,
    name: "2+Thessalonians",
    koreanName: "데살로니가후서",
  },
  디모데전서: {
    pageNumber: 6,
    name: "1+Timothy",
    koreanName: "디모데전서",
  },
  디모데후서: {
    pageNumber: 4,
    name: "2+Timothy",
    koreanName: "디모데후서",
  },
  디도서: {
    pageNumber: 3,
    name: "Titus",
    koreanName: "디도서",
  },
  빌레몬서: {
    pageNumber: 1,
    name: "Philemon",
    koreanName: "빌레몬서",
  },
  히브리서: {
    pageNumber: 13,
    name: "Hebrews",
    koreanName: "히브리서",
  },
  야고보서: {
    pageNumber: 5,
    name: "James",
    koreanName: "야고보서",
  },
  베드로전서: {
    pageNumber: 5,
    name: "1+Peter",
    koreanName: "베드로전서",
  },
  베드로후서: {
    pageNumber: 3,
    name: "2+Peter",
    koreanName: "베드로후서",
  },
  요한일서: {
    pageNumber: 5,
    name: "1+John",
    koreanName: "요한일서",
  },
  요한이서: {
    pageNumber: 1,
    name: "2+John",
    koreanName: "요한이서",
  },
  요한삼서: {
    pageNumber: 1,
    name: "3+John",
    koreanName: "요한삼서",
  },
  유다서: {
    pageNumber: 1,
    name: "Jude",
    koreanName: "유다서",
  },
  요한계시록: {
    pageNumber: 22,
    name: "Revelation",
    koreanName: "요한계시록",
  },
};
